import createAxiosInstance from './createAxiosInstance'

/*
Swagger: https://housekeeper-web-dev.kingnetsmart.com.tw/swagger/index.html#/Guest
Core Swagger: https://local.kingnetsmart.com.tw/core/index.html */

const instance = createAxiosInstance(`${process.env.VUE_APP_CORE_URL}/api`)

const mapiPath = process.env.VUE_APP_MAPI_URL
const mapiInstance = createAxiosInstance(mapiPath)

export const apiSmartLocker = {
  GetApplyStorageList: (params) => instance.get('/SmartLocker/GetApplyStorageList', { params }), // 取得待入櫃清單
  CancelApplyStorage: (requestData) => instance.put('/SmartLocker/CancelApplyStorage', requestData), // 取消待入櫃
  GetCancelReasonType: () => instance.get('/SmartLocker/GetCancelReasonType'), // 取得取消入櫃原因
  GetApplyStorageRecord: (params) => instance.get('/SmartLocker/GetApplyStorageRecord', { params }), // 取得包裹歷史紀錄
  GetCounterScenario: () => instance.get('/SmartLocker/GetCounterScenario'), // 取得櫃位狀態
  PostRemind: (requestData) => instance.post('/SmartLocker/Remind', requestData), // 已入櫃包裹再通知
  GetApplyStorageRecordImage: (params) => instance.get('/SmartLocker/GetApplyStorageRecordImage', { params }) // 已入櫃包裹再通知
}

export const mapiSmartLocker = {
  GetSmartLockerOwnerGroupListForWebAdmin: () => mapiInstance.get('/SmartLocker/GetOwnerGroupListForWebAdmin'), // 管理版Web取得指定社區的智慧櫃群組清單
  UpdateSmartLockerOwnerGroupName: (requestData) => mapiInstance.put('/SmartLocker/UpdateSmartLockerOwnerGroupName', requestData), // 更新智慧櫃群組名稱
  GetCounterScenario: (params) => mapiInstance.get('/SmartLocker/v2/GetCounterScenario', { params }), // 取得櫃位狀態
  GetContractInfo: () => mapiInstance.get('/SmartLocker/ContractInfo') // 查詢智慧櫃合約資訊
}
